import React, { useState, useEffect } from "react";
import { logo } from "../assets";
import "../NewsletterPopup.css";

const FULL_TEXT = "Subscribe to our newsletter!";

export default function NewsletterPopup() {
    const [showBubble, setShowBubble] = useState(false);
    const [formOpen, setFormOpen] = useState(false);
    const [displayText, setDisplayText] = useState("");
    const [typingKey, setTypingKey] = useState(0);
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [status, setStatus] = useState("");
    const [loading, setLoading] = useState(false);

    // Show bubble after 3s if not already subscribed
    useEffect(() => {
        const subscribed = localStorage.getItem("newsletterSubscribed");
        if (!subscribed) {
            const timer = setTimeout(() => setShowBubble(true), 3000);
            return () => clearTimeout(timer);
        }
    }, []);

    // Typewriter effect — restarts on typingKey change
    useEffect(() => {
        if (!showBubble) return;
        let i = 0;
        setDisplayText("");
        const interval = setInterval(() => {
            i++;
            setDisplayText(FULL_TEXT.slice(0, i));
            if (i >= FULL_TEXT.length) {
                clearInterval(interval);
                // Pause 3s then restart
                setTimeout(() => {
                    setDisplayText("");
                    setTimeout(() => setTypingKey(k => k + 1), 400);
                }, 3000);
            }
        }, 65);
        return () => clearInterval(interval);
    }, [showBubble, typingKey]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const res = await fetch("/api/newsletter/subscribe", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email: email.trim().toLowerCase(), source: "popup" }),
            });
            const data = await res.json();
            if (res.ok) {
                setMessage("Thank you for subscribing!");
                setStatus("success");
                setEmail("");
                localStorage.setItem("newsletterSubscribed", "true");
                setTimeout(() => {
                    setFormOpen(false);
                    setShowBubble(false);
                }, 2500);
            } else {
                setMessage(data.error || "Something went wrong. Try again.");
                setStatus("error");
            }
        } catch {
            setMessage("Unable to connect. Please try again later.");
            setStatus("error");
        }
        setLoading(false);
    };

    if (!showBubble) return null;

    return (
        <>
            {/* ── Bubble launcher ── */}
            <div className="newsletter-bubble-wrapper">
                {displayText && (
                    <div className="newsletter-speech-bubble">
                        <span>{displayText}</span>
                        <span className="newsletter-cursor">|</span>
                    </div>
                )}
                <button
                    className="newsletter-bubble-btn"
                    onClick={() => setFormOpen(true)}
                    aria-label="Subscribe to newsletter"
                >
                    <img src={logo} alt="Newsletter" className="newsletter-bubble-logo" />
                </button>
                <p className="newsletter-label">Newsletter</p>
            </div>

            {/* ── Modal form ── */}
            {formOpen && (
                <div
                    className="newsletter-modal-overlay"
                    onClick={(e) => { if (e.target === e.currentTarget) setFormOpen(false); }}
                >
                    <div className="newsletter-modal-card">
                        <button
                            className="newsletter-modal-close"
                            onClick={() => setFormOpen(false)}
                            aria-label="Close"
                        >
                            &times;
                        </button>

                        {/* Header */}
                        <div className="newsletter-modal-header">
                            <img src={logo} alt="Mainlogix" className="newsletter-logo" />
                            <h2 className="newsletter-modal-title">Newsletter</h2>
                            <p className="newsletter-modal-subtitle">
                                Stay ahead with the latest IoT insights &amp; product updates
                            </p>
                        </div>

                        {/* Body */}
                        <div className="newsletter-modal-body">
                            <p className="newsletter-modal-desc">
                                Join thousands of subscribers and be the first to know about
                                smart home products, IoT solutions, and industry news.
                            </p>
                            <form onSubmit={handleSubmit} className="newsletter-form">
                                <input
                                    type="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="Enter your email address"
                                    required
                                    className="newsletter-input"
                                />
                                <button
                                    type="submit"
                                    disabled={loading}
                                    className="newsletter-submit"
                                >
                                    {loading ? "Subscribing..." : "SUBSCRIBE NOW"}
                                </button>
                            </form>
                            {message && (
                                <p className={`newsletter-msg ${status === "success" ? "newsletter-msg-success" : "newsletter-msg-error"}`}>
                                    {message}
                                </p>
                            )}
                            <button onClick={() => setFormOpen(false)} className="newsletter-skip">
                                No thanks, I&apos;ll pass
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}
